import { render, staticRenderFns } from "./BundlePublic.vue?vue&type=template&id=c16b5b2c"
import script from "./BundlePublic.vue?vue&type=script&lang=js"
export * from "./BundlePublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports